var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchBox',{ref:"searchbox",attrs:{"label":((_vm.label) ? _vm.label : 'Plano Financeiro') + ':',"placeholder":"Busca Plano Financeiro por Nome ou Código","funcaoBuscar":"getPlanosFinanceiroLista","parametros":_vm.parametros},on:{"selected":_vm.handleSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }